'use strict';

module.exports = function(app) {

    app.notificationCheckAll = function(button) {
        var checks = $(button).parents('.js-notifications-form').find('input[type="checkbox"]');

        checks.prop('checked', true);
    };

    return app;
};
